
<fgb-banner [pageTitle]="'faq.page.title' | translate" />
<fgb-page-header [pageTitle]="'faq.page.title'" [showBalance]="false"/>

<div class="container">
  <fgbcl-faq-section></fgbcl-faq-section>
</div>
